import { StockChangeState } from '../_models';
import { translations } from '../../_translations';

export function labelForStockChangeState(state: StockChangeState): string {
  return translations.getLabel(`STOCKITEMS.STATE.OPTIONS.${state}`);
}
